import { parseCustomerAddress } from "./customerAddress.js";

export const evBrand = (details = {}) => {
  const address = parseCustomerAddress(details.address);
  const line = [address.addressLine, address.city || details.city, address.states || address.state || details.state,
    address.country || details.country, address.pincode || details.pincode].filter(Boolean).join(", ");
  return {
    name: details.company_name || "Vasudevloka Finance",
    address: line || "C/O Gali Number 11, Peoda Road, Kaithal, Haryana, India 136027",
    cin: details.cin_number || "",
  };
};

let logoPromise;
export function getEvLogoBytes() {
  if (!logoPromise) logoPromise = fetch(`${process.env.PUBLIC_URL || ""}/assets/logo1.png`)
    .then((response) => { if (!response.ok) throw new Error("Company logo could not be loaded"); return response.arrayBuffer(); })
    .then((buffer) => new Uint8Array(buffer)).catch((error) => { logoPromise = null; throw error; });
  return logoPromise;
}

export function logoDataUrl(bytes) {
  let binary = "";
  for (let index = 0; index < bytes.length; index += 0x8000)
    binary += String.fromCharCode(...bytes.subarray(index, index + 0x8000));
  return `data:image/png;base64,${btoa(binary)}`;
}
